import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Monitoring.scss';
import {
  Card,
  CardBody,
  Col,
  Row,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from 'reactstrap';
import dayjs from 'dayjs';

import { MonitoringData, SignalData, SignalTimeData } from 'api/visitReports/type';

const Monitoring: React.FC<{ monitoring_data: MonitoringData[] }> = ({ monitoring_data }) => {
  const { t } = useTranslation();
  const [openLeftIcon, setOpenLeftIcon] = useState('');
  const [innerOpenLeftIcon, setInnerOpenLeftIcon] = useState('');
  const toggleLeftIcon = (id: any) => {
    if (openLeftIcon !== id) {
      setOpenLeftIcon(id);
    }
    if (openLeftIcon === id) {
      setOpenLeftIcon('');
    }
  };

  const innerToggleLeftIcon = (id: any) => {
    if (innerOpenLeftIcon !== id) {
      setInnerOpenLeftIcon(id);
    }
    if (innerOpenLeftIcon === id) {
      setInnerOpenLeftIcon('');
    }
  };

  return (
    <Row className="m-2">
      <Col lg={12}>
        <Accordion
          className="lefticon-accordion custom-accordionwithicon accordion-border-box m-1"
          id="accordionlefticon"
          open={openLeftIcon}
          toggle={toggleLeftIcon}
        >
          <AccordionItem>
            <AccordionHeader className="py-3 accordion-header" targetId="monitoringData">
              <i className={`ri-arrow-right-s-line  fs-18 chevron ${openLeftIcon ? 'open' : ''}`} />
              {t('Monitoring.accordion-father.title')}
            </AccordionHeader>
            <AccordionBody accordionId="monitoringData">
              {monitoring_data.length === 0 ? (
                <h5 className="text-center text-danger">{t('Monitoring.accordion-father.no-data')}</h5>
              ) : (
                monitoring_data.map(trap => (
                  <Accordion
                    className="lefticon-accordion custom-accordionwithicon accordion-border-box m-1"
                    id="accordionlefticon"
                    open={innerOpenLeftIcon}
                    toggle={innerToggleLeftIcon}
                  >
                    <AccordionItem>
                      <AccordionHeader targetId={`trapData_${trap.id}`} className="py-3 accordion-header">
                        <div className="d-lg-flex align-items-center w-100">
                          {/* Column 1 1 */}
                          <div className="col-lg-1 text-center">
                            <div>
                              <i className="ri-scan-2-fill text-success fs-3" />
                            </div>
                          </div>

                          {/* Column 2 2 */}
                          <div className="col-lg-2">
                            <div className="ms-4">
                              <h5 className="fs-16 text-center mb-2">
                                {trap.trap_number ? (
                                  trap.trap_number
                                ) : (
                                  <h5 className="text-danger">
                                    {t('Monitoring.accordion-father.accordion-child.no-number')}
                                  </h5>
                                )}
                              </h5>
                              <p className="text-muted text-center mb-0">
                                {t('Monitoring.accordion-father.accordion-child.sequence-number')}
                              </p>
                            </div>
                          </div>

                          {/* Column 3 3 */}
                          <div className="col-lg-3">
                            <div className="ms-4">
                              <h5 className="fs-16 text-center mb-2">{trap?.trap_type}</h5>
                              <p className="text-muted text-center mb-0">
                                {t('Monitoring.accordion-father.accordion-child.type')}
                              </p>
                            </div>
                          </div>

                          {/* Column 4 4 */}
                          <div className="col-lg-2">
                            <div className="ms-4">
                              <h5 className="fs-16 text-center mb-2">{trap?.trap_serial_number}</h5>
                              <p className="text-muted text-center mb-0">
                                {t('Monitoring.accordion-father.accordion-child.serial-number')}
                              </p>
                            </div>
                          </div>

                          {/* Column 4 4 */}
                          <div className="col-lg-2">
                            <div className="ms-4">
                              <h5 className="fs-16 text-center mb-2">{trap?.install_date}</h5>
                              <p className="text-muted text-center mb-0">
                                {t('Monitoring.accordion-father.accordion-child.install-date')}
                              </p>
                            </div>
                          </div>

                          {/* Column 4 4 */}
                          <div className="col-lg-2">
                            <div className="ms-4">
                              <h5 className="fs-16 text-center mb-2">{trap?.remove_date}</h5>
                              <p className="text-muted text-center mb-0">
                                {t('Monitoring.accordion-father.accordion-child.remove-date')}
                              </p>
                            </div>
                          </div>
                        </div>
                      </AccordionHeader>
                      <AccordionBody accordionId={`trapData_${trap.id}`}>
                        {trap?.signals_data && trap.signals_data !== '[]' ? (
                          JSON.parse(trap.signals_data).map((signal: SignalData) => (
                            <Card className="card border mb-1">
                              <CardBody>
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                  }}
                                >
                                  <h4 className="m-2 fs-16 d-flex align-items-center" style={{ whiteSpace: 'nowrap' }}>
                                    {t('Monitoring.accordion-father.accordion-child.accordion-inner-child.row-name')}{' '}
                                    {dayjs(signal?.date).format('DD-MM-YYYY')}
                                  </h4>
                                  <div className="card m-3 w-100 card-to-line" />
                                  <div className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                    <UncontrolledDropdown className="m-2">
                                      <DropdownToggle tag="button" className="btn btn-light">
                                        {t(
                                          'Monitoring.accordion-father.accordion-child.accordion-inner-child.dropdown-title',
                                        )}{' '}
                                        {dayjs(signal?.date).format('DD-MM-YYYY')}{' '}
                                        <i className="mdi mdi-chevron-down" />
                                      </DropdownToggle>
                                      <DropdownMenu>
                                        <DropdownItem>
                                          <table
                                            id={`trapSignals_${trap.id}`}
                                            className="table table-nowrap"
                                            style={{ width: '100%' }}
                                          >
                                            <thead className="">
                                              <tr>
                                                <th scope="col" style={{ width: '50%' }} className="text-center">
                                                  {t(
                                                    'Monitoring.accordion-father.accordion-child.accordion-inner-child.dropdown-inner.time',
                                                  )}
                                                </th>
                                                <th scope="col" style={{ width: '50% ' }} className="text-center">
                                                  {t(
                                                    'Monitoring.accordion-father.accordion-child.accordion-inner-child.dropdown-inner.pest-amount',
                                                  )}
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody className="list form-check-all">
                                              {signal.time.map((time: SignalTimeData, index: number) => (
                                                <tr className="align-center text-center">
                                                  <td id={`DateIndex_${index}`}>
                                                    <i className="ri-timer-flash-line fs-18 text-success" />{' '}
                                                    {dayjs(time.inner_time).format('HH:mm:ss')}
                                                  </td>
                                                  <td id={`TimeIndex_${index}`}>
                                                    <i className="ri-mickey-fill fs-18 text-danger mr-3" />{' '}
                                                    {time.amount}
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          ))
                        ) : (
                          <h5 className="text-danger text-center">{t('Monitoring.accordion-father.no-signal')}</h5>
                        )}
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                ))
              )}
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </Col>
    </Row>
  );
};

export default Monitoring;
